/* eslint-disable eqeqeq */
/* eslint-disable no-console */
/* eslint-disable no-shadow-restricted-names */
/* eslint-disable no-unused-vars */
/* global $ */
/* global app */

app.page.home = ( function( window, document, undefined ) {
	const $html = $( 'html' );

	/**
	 * Page initialization
	 *
	 * @access public
	 * @interface page.home.start
	 * @example page.home.start()
	 */
	const _pageInit = function() {
		_heroVideo.init();
		_featureCards.init();
		_napsterRail.init();
	};

	const _heroVideo = {
		init() {
			class VideoResponser {
				constructor( selector ) {
					const $video = document.querySelector( selector );
					this.options = {
						selector,
						breakpoints: {
							default: {
								src: $video.getAttribute( 'data-src' ),
							},
						},
					};

					$video.querySelectorAll( '[data-src]' ).forEach( ( element ) => this.options.breakpoints[ element.getAttribute( 'data-mw' ) ] = {
						src: element.getAttribute( 'data-src' ),
					} );
					$video.innerHTML = '';

					this.responseVideo( this.options );
					this.resizer();
				}

				resizer() {
					window.addEventListener( 'resize', () => this.responseVideo( this.options ) );
				}

				responseVideo( options ) {
					const {
						selector,
						breakpoints,
					} = options;
					const $video = document.querySelector( selector );
					const widthNow = $video.getAttribute( 'data-width-now' ) || null;
					const maxBreakpoint = Math.max.apply( Math, Object.keys( breakpoints ).filter( ( key ) => key <= document.body.clientWidth ).map( Number ) );
					const nowBreakpoint = maxBreakpoint || 'default';
					if ( widthNow && widthNow == nowBreakpoint ) {
						return;
					}

					$video.setAttribute( 'data-width-now', nowBreakpoint );
					$video.src = breakpoints[ nowBreakpoint ].src;
				}
			}

			new VideoResponser( '.hero-video' );
		},
	};

	const _featureCards = {
		osHasReducedMotion() {
			if ( ! window.matchMedia ) {
				return false;
			}
			const matchMediaObj = window.matchMedia( '(prefers-reduced-motion: reduce)' );
			if ( matchMediaObj ) {
				return matchMediaObj.matches;
			}
			return false; // return false if not supported
		},
		init() {
			/*
        Polyfills
      */
			//Closest() method
			if ( ! Element.prototype.matches ) {
				Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
			}

			if ( ! Element.prototype.closest ) {
				Element.prototype.closest = function( s ) {
					let el = this;
					if ( ! document.documentElement.contains( el ) ) {
						return null;
					}
					do {
						if ( el.matches( s ) ) {
							return el;
						}
						el = el.parentElement || el.parentNode;
					} while ( el !== null && el.nodeType === 1 );
					return null;
				};
			}

			//Custom Event() constructor
			function CustomEvent( event, params ) {
				params = params || {
					bubbles: false,
					cancelable: false,
					detail: undefined,
				};
				const evt = document.createEvent( 'CustomEvent' );
				evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
				return evt;
			}

			if ( typeof window.CustomEvent !== 'function' ) {
				CustomEvent.prototype = window.Event.prototype;

				window.CustomEvent = CustomEvent;
			}

			/*
			Animation curves
			*/
			Math.easeInOutQuad = function( t, b, c, d ) {
				t /= d / 2;
				if ( t < 1 ) {
					return c / 2 * t * t + b;
				}
				t--;
				return -c / 2 * ( t * ( t - 2 ) - 1 ) + b;
			};

			/* JS Utility Classes */
			// make focus ring visible only for keyboard navigation (i.e., tab key)
			const focusTab = document.getElementsByClassName( 'js-tab-focus' );

			function detectClick() {
				if ( focusTab.length > 0 ) {
					resetFocusTabs( false );
					window.addEventListener( 'keydown', detectTab );
				}
				window.removeEventListener( 'mousedown', detectClick );
			}

			function detectTab( event ) {
				if ( event.keyCode !== 9 ) {
					return;
				}
				resetFocusTabs( true );
				window.removeEventListener( 'keydown', detectTab );
				window.addEventListener( 'mousedown', detectClick );
			}

			function resetFocusTabs( bool ) {
				const outlineStyle = bool ? '' : 'none';
				for ( let i = 0; i < focusTab.length; i++ ) {
					focusTab[ i ].style.setProperty( 'outline', outlineStyle );
				}
			}
			window.addEventListener( 'mousedown', detectClick );

			const StackCards = function( element ) {
				this.element = element;
				this.items = this.element.getElementsByClassName( 'js-stack-cards__item' );
				this.scrollingFn = false;
				this.scrolling = false;
				initStackCardsEffect( this );
				initStackCardsResize( this );
			};

			function initStackCardsEffect( element ) { // use Intersection Observer to trigger animation
				setStackCards( element ); // store cards CSS properties
				const observer = new IntersectionObserver( stackCardsCallback.bind( element ), {
					threshold: [ 0, 1 ],
				} );
				observer.observe( element.element );
			}

			function initStackCardsResize( element ) { // detect resize to reset gallery
				element.element.addEventListener( 'resize-stack-cards', function() {
					setStackCards( element );
					animateStackCards.bind( element );
				} );
			}

			function stackCardsCallback( entries ) { // Intersection Observer callback
				if ( entries[ 0 ].isIntersecting ) {
					if ( this.scrollingFn ) {
						return;
					} // listener for scroll event already added
					stackCardsInitEvent( this );
				} else {
					if ( ! this.scrollingFn ) {
						return;
					} // listener for scroll event already removed
					window.removeEventListener( 'scroll', this.scrollingFn );
					this.scrollingFn = false;
				}
			}

			function stackCardsInitEvent( element ) {
				element.scrollingFn = stackCardsScrolling.bind( element );
				window.addEventListener( 'scroll', element.scrollingFn );
			}

			function stackCardsScrolling() {
				if ( this.scrolling ) {
					return;
				}
				this.scrolling = true;
				window.requestAnimationFrame( animateStackCards.bind( this ) );
			}

			function setStackCards( element ) {
				// store wrapper properties
				element.marginY = getComputedStyle( element.element ).getPropertyValue( '--stack-cards-gap' );
				getIntegerFromProperty( element ); // convert element.marginY to integer (px value)
				element.elementHeight = element.element.offsetHeight;

				// store card properties
				const cardStyle = getComputedStyle( element.items[ 0 ] );
				element.cardTop = Math.floor( parseFloat( cardStyle.getPropertyValue( 'top' ) ) );
				element.cardHeight = Math.floor( parseFloat( cardStyle.getPropertyValue( 'height' ) ) );

				// store window property
				element.windowHeight = window.innerHeight;

				// reset margin + translate values
				if ( isNaN( element.marginY ) ) {
					element.element.style.paddingBottom = '0px';
				} else {
					element.element.style.paddingBottom = ( element.marginY * ( element.items.length - 1 ) ) + 'px';
				}

				for ( let i = 0; i < element.items.length; i++ ) {
					if ( isNaN( element.marginY ) ) {
						element.items[ i ].style.transform = 'none;';
					} else {
						element.items[ i ].style.transform = 'translateY(' + element.marginY * i + 'px)';
					}
				}
			}
			function getIntegerFromProperty( element ) {
				const node = document.createElement( 'div' );
				node.setAttribute( 'style', 'opacity:0; visbility: hidden;position: absolute; height:' + element.marginY );
				element.element.appendChild( node );
				element.marginY = parseInt( getComputedStyle( node ).getPropertyValue( 'height' ) );
				element.element.removeChild( node );
			}
			function animateStackCards() {
				if ( isNaN( this.marginY ) ) { // --stack-cards-gap not defined - do not trigger the effect
					this.scrolling = false;
					return;
				}

				const top = this.element.getBoundingClientRect().top;

				if ( this.cardTop - top + this.element.windowHeight - this.elementHeight - this.cardHeight + this.marginY + this.marginY * this.items.length > 0 ) {
					this.scrolling = false;
					return;
				}

				for ( let i = 0; i < this.items.length; i++ ) { // use only scale
					const scrolling = this.cardTop - top - i * ( this.cardHeight + this.marginY );
					if ( scrolling > 0 ) {
						const scaling = i == this.items.length - 1 ? 1 : ( this.cardHeight - scrolling * 0.05 ) / this.cardHeight;
						this.items[ i ].style.transform = 'translateY(' + this.marginY * i + 'px) scale(' + scaling + ')';
					} else {
						this.items[ i ].style.transform = 'translateY(' + this.marginY * i + 'px)';
					}
				}

				this.scrolling = false;
			}

			// initialize StackCards object
			const stackCards = document.getElementsByClassName( 'js-stack-cards' ),
				intersectionObserverSupported = ( 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype ),
				reducedMotion = _featureCards.osHasReducedMotion();

			if ( stackCards.length > 0 && intersectionObserverSupported && ! reducedMotion ) {
				const stackCardsArray = [];
				for ( let i = 0; i < stackCards.length; i++ ) {
					( function( j ) {
						stackCardsArray.push( new StackCards( stackCards[ j ] ) );
					}( i ) );
				}

				let resizingId = false;

				const customEvent = new CustomEvent( 'resize-stack-cards' );

				window.addEventListener( 'resize', function() {
					clearTimeout( resizingId );
					resizingId = setTimeout( doneResizing, 500 );
				} );

				function doneResizing() {
					for ( let i = 0; i < stackCardsArray.length; i++ ) {
						( function( j ) {
							stackCardsArray[ j ].element.dispatchEvent( customEvent );
						}( i ) );
					}
				}
			}

			_featureCards.animationsInit();
		},
		animationsInit() {
			$( '[data-animation]' ).each( ( i, el ) => {
				const $el = $( el );
				const $card = $el.parents( 'li' ).first();
				const animation = $el.data();

				// fetch animation and animate element
				app.animations.animate(
					animation.animation,
					$el.children().first()[ 0 ],
					animation.animationPath,
					animation.animationLoop || false,
					animation.animationAutoplay || false,
				);

				// start animation if autoplay is turned off
				if ( ! animation.animationAutoplay ) {
					window[ $card.attr( 'id' ) + '_waypoint' ] = new window.Waypoint( {
						element: $card[ 0 ],
						handler( direction ) {
							window[ animation.animation ].play();
						},
						offset: '25%',
					} );
				}
			} );
		},
	};

	const _napsterRail = {
		fetchImages() {
			const $exclusiveRail = $( '#exclusive-slider' );

			const albumsRequestOptions = {
				method: 'GET',
				headers: {
					apikey: 'NDRlODJiM2EtM2UwNi00OTAzLTlhZDktOTZlMDg5YmY4MGYz',
				},
				redirect: 'follow',
			};

			const railAlbums = new Promise( ( resolve, reject ) => {
				fetch( $exclusiveRail.data().albumsApi, albumsRequestOptions )
					.then( ( response ) => response.text() )
					.then( ( result ) => {
						const albums = JSON.parse( result ).albums;

						const albumsImages = albums.map( ( album ) => {
							return {
								type: 'album',
								image: ( $html.data().siteNapiUrl || 'https://api.napster.com' ) + '/imageserver/v2/albums/' + album.id + '/images/300x300.jpg',
								href: 'https://play.napster.com/album/' + album.id,
								title: album.name + ': ' + album.artistName,
								alt: 'Album: ' + album.name,
							};
						} );

						resolve( albumsImages );
					} );
			} );

			const videoRequestOptions = {
				method: 'GET',
				headers: {
					'x-client-id': '98a786f5-6cc9-4950-9532-52214988f44e',
				},
				redirect: 'follow',
			};

			const railVideos = new Promise( ( resolve, reject ) => {
				fetch( $exclusiveRail.data().videosApi, videoRequestOptions )
					.then( ( response ) => response.text() )
					.then( ( result ) => {
						const videos = JSON.parse( result ).videos;

						const videoImages = videos.map( ( video ) => {
							return {
								type: 'video',
								image: video.images[ 0 ].url,
								href: 'https://play.napster.com/videos/' + video.id,
								title: video.name,
								alt: 'Video: ' + video.name,
							};
						} );

						resolve( videoImages );
					} );
			} );

			Promise.all( [ railAlbums, railVideos ] )
				.then( ( results ) => {
					let allImages = [];

					results.forEach( ( images ) => {
						allImages = allImages.concat( images );
					} );

					// shuffle images
					allImages.sort( () => ( Math.random() > .5 ) ? 1 : -1 );

					// fill images batch up to 60 images
					do {
						allImages = allImages.concat( allImages );
					}
					while ( allImages.length <= 60 );

					if ( allImages.length > 60 ) {
						allImages = allImages.slice( 0, 60 );
					}

					// divide images into two batches
					const halfImages = Math.ceil( allImages.length / 2 );

					if ( allImages.length > 0 ) {
						$( 'body' ).addClass( 'rail-visible' );
					}

					_napsterRail.setImages(
						allImages.slice( 0, halfImages ),
						'.slider-top .slider-wrapper',
						() => {
							_napsterRail.setSlider( '.slider-top', 'smoothscroll' );
						},
					);

					_napsterRail.setImages(
						allImages.slice( -halfImages ),
						'.slider-bottom .slider-wrapper',
						() => {
							_napsterRail.setSlider( '.slider-bottom', 'smoothscrollreversed' );
						},
					);
				} );
		},

		setImages( images, container, callback ) {
			const $container = $( container );

			images.forEach( ( image ) => {
				$container.append( '<div class="slide"><a href="' + image.href + '" title="' + image.title + '" class="slide-inner"><img src="' + image.image + '" alt="' + image.alt + '"></a></div>' );
			} );

			setTimeout( () => {
				callback();
			}, 1000 );
		},

		setSlider( container, animation ) {
			const slide = '> div > div';
			const firstSlide = '> div > div:first-of-type';
			const containerWidth = $( container ).width();
			const slideWidth = $( firstSlide, container ).outerWidth( false );
			const sliderHeight = $( firstSlide, container ).outerHeight( false );

			let sliderWidth = 0;
			let animationWidth = 0;

			$( slide, container ).each( ( index, element ) => {
				animationWidth += $( element ).outerWidth( false );
			} );

			// detect number of visible slides
			let slidesVisible = containerWidth / slideWidth;

			slidesVisible = Math.ceil( slidesVisible );

			// count slides to determine animation speed
			const slidesNumber = $( slide, container ).length;
			const speed = slidesNumber * 4;

			// append the tail
			$( slide, container ).slice( 0, slidesVisible ).clone().appendTo( $( '>div', container ) );

			const slidesWidth = slideWidth * slidesNumber;

			if ( slidesWidth < containerWidth ) {
				$( slide, container ).slice( 0, slidesVisible ).clone().appendTo( $( '>div', container ) );
			}

			// Detect the slider width with appended tail
			$( slide, container ).each( ( index, element ) => {
				sliderWidth += $( element ).outerWidth( false );
			} );

			// set slider dimensions
			$( '>div', container ).css( {
				width: sliderWidth,
				height: sliderHeight,
			} );

			// Insert styles to html
			$( "<style type='text/css'>@keyframes " + animation + ' { 0% { margin-left: 0px; } 100% { margin-left: -' + animationWidth + 'px; } } ' + container + firstSlide + ' { -webkit-animation: ' + animation + ' ' + speed + 's linear infinite; -moz-animation: ' + animation + ' ' + speed + 's linear infinite; -ms-animation: ' + animation + ' ' + speed + 's linear infinite; -o-animation: ' + animation + ' ' + speed + 's linear infinite; animation: ' + animation + ' ' + speed + 's linear infinite; }</style>' ).appendTo( 'head' );
		},

		init() {
			_napsterRail.fetchImages();
		},
	};

	return {
		start: _pageInit,
	};
}( this, this.document ) );

// Init page
$( () => {
	app.page.home.start();
} );
